import React from "react";
import PropTypes from 'prop-types';
import {Card, CardContent, makeStyles, Typography, Avatar} from "@material-ui/core";
import {Link} from 'gatsby';
import {linkReset} from "../helpers/linkReset";
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
    linkReset: {
        ...linkReset,
        cursor: 'pointer',
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    avatar: {
        height: 64,
        width: 64,
    },
    card: {
        '&:hover': {
            boxShadow: theme.shadows[8],
        }
    }
}));

export const WorkshopPreview = (props) => {
    const classes = useStyles();

    return <Link to={props.slug} className={classes.linkReset}>
        <Card className={classNames(props.className, classes.card)} elevation={4}>
            <CardContent>
                <div className={classes.cardHeader}>
                    <div>
                        <Typography variant='h4' component='h2'>{props.title}</Typography>
                        {props.subtitle && <Typography color={"textSecondary"} variant={"h6"}>{props.subtitle}</Typography>}
                    </div>
                    <Avatar className={classes.avatar} alt={props.name}
                            src={props.image}/>
                </div>
                <Typography>{props.text}</Typography>
            </CardContent>
        </Card>
    </Link>;
};

WorkshopPreview.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    text: PropTypes.string.isRequired,
    slug: PropTypes.string,
    className: PropTypes.string,
};